// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3O2pZ","ranges":"BmiRanges_ranges__YcyPw"};